<template>
  <component :is="component" />
</template>

<script>
import PlatformSlider from '@/components/sidepanels/PlatformSlider';
import TimeLine from '@/components/sidepanels/TimeLine';

export default {
  name: 'SidePanel',
  components: {
    PlatformSlider,
    TimeLine
  },
  computed: {
    component() {
      return this.$store.state.sidepanel;
    }
  }
}
</script>

<style>

</style>
